import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMisssionSHE } from "../../actions/homeActions";
export default () => {
  const [jobHasMorePages, setEventsHasMorePages] = useState(false);
  const [additionalEvents, setAdditionalEvents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL;
  const {
    data: allMissionSHEData,
    isLoading,
    isError,
    error,
  } = useMisssionSHE(currentPage);
  useEffect(() => {
    if (allMissionSHEData) {
      setEventsHasMorePages(allMissionSHEData?.has_more_pages);
      setAdditionalEvents((prevProject) => {
        const newProject = allMissionSHEData?.mission_she || [];
        const uniqueJobs = [...prevProject, ...newProject].reduce(
          (acc, project) => {
            if (!acc.some((j) => j.id === project.id)) {
              acc.push(project);
            }
            return acc;
          },
          []
        );
        return uniqueJobs;
      });
    }
  }, [allMissionSHEData]);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading mission SHE: {error.message}
        </p>
      </div>
    );
  }

  const handleEvents = (id) => {
    navigate(`/missionShe-details/${id}`);
  };
  return {
    allMissionSHEData,
    additionalEvents,
    handleEvents,
    baseURL,
    isLoading,
    jobHasMorePages,
    setCurrentPage,
  };
};
